// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lazy-loading-spinner {
  position: fixed;
  width: 100%;
  height: 100vh;
  background-color: #fff;
  border-radius: 10px;
  z-index: 55;
}

.dark .lazy-loading-spinner {
  background-color: var(--darkSecondColor);
}

@media (max-width: 1000px) {
  .lazy-loading-spinner {
    width: calc(100% - 20px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Ui/LoadingSpinner/loadingSpinner.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AACF;;AAEE;EACE,wCAAA;AACJ;;AAEA;EACE;IACE,wBAAA;EACF;AACF","sourcesContent":[".lazy-loading-spinner {\n  position: fixed;\n  width: 100%;\n  height: 100vh;\n  background-color: #fff;\n  border-radius: 10px;\n  z-index: 55;\n}\n.dark {\n  .lazy-loading-spinner {\n    background-color: var(--darkSecondColor);\n  }\n}\n@media (max-width: 1000px) {\n  .lazy-loading-spinner {\n    width: calc(100% - 20px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
